<template>
  <prize-user :avatar="source.avatar"
              :username="source.username"
              :level="source.level"
              :points="source.points"
              :rank="source.rank"/>
</template>

<script>
import PrizeUser from './PrizeUser';

export default {
  name: 'item-wrapper',
  props: {
    source: Object,
  },
  components: {
    PrizeUser,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/sharedcomponents/PrizeUserWrapper.vue